import React from 'react';

import ScrollOnTopButton from './ScrollOnTopButton';
import WhatsAppButton from './ButtonWhatsapp';

function ButtonHelpWrapper() {
  return (
    <div className="fixed right-8 bottom-8 z-50 flex flex-col items-end gap-6">
      {/* Scroll to Top Button */}
      <ScrollOnTopButton />

      {/* WhatsApp Button */}
      <WhatsAppButton />
      
    </div>
  );
}

export default ButtonHelpWrapper;